import gql from 'graphql-tag';

export default gql`
  query ($contentGroupId: MongoID!, $studentId: MongoID!) {
    contentGroupProgress(contentGroupId: $contentGroupId, studentId: $studentId) {
      contentGroupId
      studentId
      totalContents
      completedContents
      progressPercent
    }
  }
`;
